// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#carousel {
  /* height: 810px; */
  width: 100%;
  aspect-ratio: 8/5;
  max-height: 90vh;
}

#carousel .content-wrapper {
  position: relative;
}

#carousel .text-wrapper {
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 0 2rem;
  background-color: rgba(0, 0, 0, 0.35);
}

#carousel h3 {
  color: white;
  font-size: 3rem;
  text-align: center;
  padding: 0;
  margin: -2rem 0 0 0;
  text-shadow: 0px 0px 24px rgba(0, 0, 0, 1);
  max-width: 1024px;
}

#carousel p {
  color: white;
  font-size: 1.3rem;
  text-align: center;
  padding: 0;
  margin: 0;
  line-height: 1.4;
  text-shadow: 0px 0px 16px rgba(0, 0, 0, 1);
}

.slick-dots {
  display: block;
  transform: translateY(-6rem);
}

.slick-dots li button {
}

.slick-dots li button:before {
  background-color: var(--gray-dark);
  color: var(--gray-dark);
  opacity: 1;
}

.slick-dots li.slick-active button:before {
  background-color: var(--orange);
  color: var(--orange);
  opacity: 1;
}

#carousel img {
  object-fit: cover;
  width: 100vw;
  aspect-ratio: 8/5;
  max-height: 90vh;
}

/* MOBILE */

@media (max-width: 768px) {
  #carousel {
    /* height: 375px; */
    min-height: 400px;
  }

  #carousel img {
    /* height: 375px; */
    min-height: 400px;
  }

  #carousel h3 {
    margin: -3rem 0 0 0;
    font-size: 2rem;
  }

  #carousel p {
    font-size: 1.2rem;
  }

  .slick-dots {
    transform: translateY(-5rem);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Carousel.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,0CAA0C;EAC1C,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;AACA;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,+BAA+B;EAC/B,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,WAAW;;AAEX;EACE;IACE,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,4BAA4B;EAC9B;AACF","sourcesContent":["#carousel {\n  /* height: 810px; */\n  width: 100%;\n  aspect-ratio: 8/5;\n  max-height: 90vh;\n}\n\n#carousel .content-wrapper {\n  position: relative;\n}\n\n#carousel .text-wrapper {\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  box-sizing: border-box;\n  padding: 0 2rem;\n  background-color: rgba(0, 0, 0, 0.35);\n}\n\n#carousel h3 {\n  color: white;\n  font-size: 3rem;\n  text-align: center;\n  padding: 0;\n  margin: -2rem 0 0 0;\n  text-shadow: 0px 0px 24px rgba(0, 0, 0, 1);\n  max-width: 1024px;\n}\n\n#carousel p {\n  color: white;\n  font-size: 1.3rem;\n  text-align: center;\n  padding: 0;\n  margin: 0;\n  line-height: 1.4;\n  text-shadow: 0px 0px 16px rgba(0, 0, 0, 1);\n}\n\n.slick-dots {\n  display: block;\n  transform: translateY(-6rem);\n}\n\n.slick-dots li button {\n}\n\n.slick-dots li button:before {\n  background-color: var(--gray-dark);\n  color: var(--gray-dark);\n  opacity: 1;\n}\n\n.slick-dots li.slick-active button:before {\n  background-color: var(--orange);\n  color: var(--orange);\n  opacity: 1;\n}\n\n#carousel img {\n  object-fit: cover;\n  width: 100vw;\n  aspect-ratio: 8/5;\n  max-height: 90vh;\n}\n\n/* MOBILE */\n\n@media (max-width: 768px) {\n  #carousel {\n    /* height: 375px; */\n    min-height: 400px;\n  }\n\n  #carousel img {\n    /* height: 375px; */\n    min-height: 400px;\n  }\n\n  #carousel h3 {\n    margin: -3rem 0 0 0;\n    font-size: 2rem;\n  }\n\n  #carousel p {\n    font-size: 1.2rem;\n  }\n\n  .slick-dots {\n    transform: translateY(-5rem);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
